import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Bug } from "lucide-react";

interface NutMessageToggleProps {
  onClick: () => void;
}

export function NutMessageToggle({ onClick }: NutMessageToggleProps) {
  if (!import.meta.env.VITE_ENABLE_APP_MESSAGES) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={onClick}
          className="p-2 w-10 h-10 rounded-md bg-secondary hover:bg-accent transition-colors border border-border"
          title="Open message overlay"
        >
          <Bug size={20} className="text-foreground" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Report Bug</TooltipContent>
    </Tooltip>
  );
}

export default NutMessageToggle;
